import React, { useState, useEffect } from 'react';
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card.js';
import HeatMap from 'components/charts/Heatmap';

import {
    sampleGlycogeneHeatMapData,
    sampleGlycogeneHeatMapOptions,
    fetchGlycogeneHeatMapData,
} from "views/admin/analysisGlycosylation/variables/data";

export default function Conversion(props) {
    const { ...rest } = props;

    // Chakra Color Mode
    const cardColor = useColorModeValue('white', 'navy.700');
    const cardShadow = useColorModeValue(
        '0px 18px 40px rgba(112, 144, 176, 0.12)',
        'unset'
    );

    const [chartData, setChartData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [categories, setCategories] = useState([]);


    useEffect(() => {
        const fetchDataAndUpdateState = async () => {
            try {
                setIsLoading(true);
                const newData = await fetchGlycogeneHeatMapData();

                setChartData(newData.data);
            
                setCategories(newData.genes);
                setIsLoading(false);
            } catch (error) {
                console.error('An error occurred while fetching data:', error);
                setHasError(true);
                setIsLoading(false);
            }
        };
        fetchDataAndUpdateState();
    }, []);

    const options = { // Dynamically set the options
        ...sampleGlycogeneHeatMapOptions,
        xaxis: {
          ...sampleGlycogeneHeatMapOptions.xaxis,
          categories: categories
        }
      };


    return (
        <Card p='20px' align='center' direction='column' w='100%' {...rest}>

            {isLoading ? (
                <p>Loading...</p>
            ) : hasError ? (
                <p>Error occurred while fetching data.</p>
            ) : (
                <HeatMap options={options} data={chartData} />
            )}

        </Card>
    );
}
